import { render, staticRenderFns } from "./EditSPEmployeeProfileControlButtons.vue?vue&type=template&id=5b3e8914&scoped=true"
import script from "./EditSPEmployeeProfileControlButtons.vue?vue&type=script&lang=js"
export * from "./EditSPEmployeeProfileControlButtons.vue?vue&type=script&lang=js"
import style0 from "./EditSPEmployeeProfileControlButtons.vue?vue&type=style&index=0&id=5b3e8914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3e8914",
  null
  
)

export default component.exports